module.exports = __webpack_public_path__ + "img/code-reviewer.33c5ac70.jpeg";